import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const disableWhatsapp = async (userId) => {

  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.TOGGLE_WHATSAPP}/${userId}`;

  return new Promise((resolve, reject) => {
    axios
      .patch(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default disableWhatsapp;
